import * as React from 'react';
import { FC } from 'react';
import { BaseButtonProps } from '../types/global';
import { Button } from '@mui/material';

const BaseButton: FC<BaseButtonProps> = ({
  variant = 'contained',
  text,
  color,
  isDisabled,
  spinner,
  onClick,
  customStyle = {},
  size = 'medium',
  sx = {},
}) => {
  return (
    <Button
      size={size}
      variant={variant}
      style={customStyle}
      disabled={isDisabled}
      onClick={onClick}
      color={color}
      loading={spinner}
      sx={{
        textTransform: 'none',
        ...sx,
      }}
    >
      {text}
    </Button>
  );
};

export default BaseButton;
